<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<div class="container-fluid">
  <!-- 404 Error Text -->
  <div class="text-center">
    <div class="error mx-auto" data-text="404">404</div>
    <p class="lead text-gray-800 mb-5">Page Not Found</p>
    <p class="text-gray-500 mb-0">
      Ahh . . ! you've just came to a wrong page !
    </p> <br>
    <a href="javascript:void(0)" (click)="getback()">&larr; Take me back</a>
  </div>
<br><br><br>
 <div align="center">
   Want to report an issue ? <br><br><br>
   <a href="javascript:void(0)"  align="center"><small>Talk to the developer : Bhaskar | bskrksyp9@zoho.com</small> </a>
 </div>
 </div>